import type { StudyView } from '@/models/view';
import { EmptyState } from '@/shared/ui/EmptyState';
import RecentlyViewed from '../RecentlyViewed';

interface ReaderEmptyStateProps {
  hasPendingStudies: boolean;
  recentlyViewed: StudyView[];
  hasAssignments: boolean;
}

export default function ReaderEmptyState({
  hasPendingStudies,
  recentlyViewed,
  hasAssignments,
}: ReaderEmptyStateProps) {
  const hasRecents = recentlyViewed.length > 0;

  let headline: string;
  let subtext: string;

  if (hasAssignments) {
    headline = 'Select a study to begin reading';
    subtext =
      'Choose a study from the worklist to open the viewer and worksheet.';
  } else if (!hasPendingStudies && hasRecents) {
    headline = 'You\u2019re all caught up';
    subtext = 'New studies will show up as soon as they\u2019re assigned.';
  } else {
    headline = "You're all caught up";
    subtext = "New studies will show up as soon as they're assigned.";
  }

  return (
    <EmptyState headline={headline} subtext={subtext}>
      {hasRecents && <RecentlyViewed studies={recentlyViewed} />}
    </EmptyState>
  );
}
